import { render, staticRenderFns } from "./exhibition.vue?vue&type=template&id=d59cde26&scoped=true"
import script from "./exhibition.vue?vue&type=script&lang=js"
export * from "./exhibition.vue?vue&type=script&lang=js"
import style0 from "./exhibition.vue?vue&type=style&index=0&id=d59cde26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59cde26",
  null
  
)

export default component.exports